import { tgxApi } from "../../../app/tgxApi";
import {
    getAuthorizationHeader,
    getFileDownloadHeaders,
    handleQueryError,
    handleQueryErrorAndSuccess
} from "../../../helpers/utils/RtkQueryUtils";
import { getFileName, serialize } from "../../../helpers/utils/Utils";
import { downloadFile } from "../../../helpers/utils/FileUtils";

export const scraperModuleApi = tgxApi.injectEndpoints({
    endpoints: (build) => ({

        searchScraperModules: build.query({
            query: (data) => {
                // Serialize the data to query parameters
                let paramData = serialize(data);
                return {
                    url: `/ajax/scraper-modules?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['scraperModules'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),

        getScraperModulesList: build.query({
            query: () => {
                return {
                    url: `/ajax/get-scraper-modules-list`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['scraperModulesList'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),

        getScraperModuleById: build.query({
            query: (id) => {
                return {
                    url: `/ajax/get-scraper-modules/${id}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['scraperModuleById'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        createScraperModule: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/ajax/create/scraperModule`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['scraperModules'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Created", "ScraperModule");
            },
        }),
        updateScraperModule: build.mutation({
            query: ({ id, requestBody }) => {
                return {
                    url: `/ajax/update/scraperModule/${id}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['scraperModules', 'scraperModuleById', 'userAuditableInfo'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Scraper Module")
            },
        }),

        deleteScraperModuleById: build.mutation({
            query: (id) => {
                return {
                    url: `/ajax/modules/scraper/${id}`,
                    method: 'DELETE',
                    headers: getAuthorizationHeader()
                };
            },
            invalidatesTags: ['scraperModules'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Deleted", "Scraper Module");
            },
        }),
        exportScraperModulesData: build.query({
            query: (query) => {
                return {
                    url: `/export/scraper`,
                    method: 'POST',
                    params: query,
                    headers: getFileDownloadHeaders(),
                    responseType: 'arraybuffer',
                    responseHandler: async (response: { blob: () => any; }) => {
                        const blob = await response.blob();
                        downloadFile(blob, getFileName("scraperModuleData"))
                        return { success: true };
                    },
                };
            },
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),

    }),
});


export const {
    useGetScraperModuleByIdQuery,
    useUpdateScraperModuleMutation,
    useSearchScraperModulesQuery,
    useDeleteScraperModuleByIdMutation,
    useLazyExportScraperModulesDataQuery,
    useCreateScraperModuleMutation,
    useGetScraperModulesListQuery
} = scraperModuleApi;